import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import { addEntities } from "../../entities";
import {
  FETCH_QUERY_DEBTORS_FAILURE,
  FETCH_QUERY_DEBTORS_REQUEST,
  FETCH_QUERY_DEBTORS_SUCCESS
} from "../types";

const debounced = debounce(
  async (dispatch, schema, api, status, limit, offset, ordering, filters) => {
    dispatch(
      createAction(FETCH_QUERY_DEBTORS_REQUEST)({
        status,
        limit,
        offset,
        ordering,
        filters
      })
    );
    const response = await api.debtors.getDebtors(
      status,
      ordering,
      limit,
      offset,
      filters
    );
    const data = normalize(response.results, [schema.debtors]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_QUERY_DEBTORS_SUCCESS)({
        items: data.result,
        count: response.count,
        status,
        limit,
        offset,
        ordering,
        filters
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);

export default (status, ordering, limit, offset, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(
      dispatch,
      schema,
      api,
      status,
      limit,
      offset,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_QUERY_DEBTORS_FAILURE)(err));
    throw err;
  }
};
